var FuzzinessOption;
(function (FuzzinessOption) {
    FuzzinessOption["ON"] = "ON";
    FuzzinessOption["OFF"] = "OFF";
    FuzzinessOption["DEFAULT"] = "DEFAULT";
})(FuzzinessOption || (FuzzinessOption = {}));

export { FuzzinessOption as F };

//# sourceMappingURL=roche-search.types.js.map